module.exports = __webpack_public_path__ + "img/MIGRATION.bfd12b40.svg";